import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * Calculate serviceability by pickup distance.
 */
export const schema = z.boolean();

export type ServiceableRadiusByPickup = z.infer<typeof schema>;

export const definition = define({
  key: 'serviceable_radius_by_pickup',
  schema,
  label: 'Pickup Verification for HopDrive Service Radius',
  description: 'Toggle on to verify that the pickup address is within the HopDrive Service Radius.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.SERVICE_RADIUS.key,
  writableAtLevels: [LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
});
